import { EditPredictionsSVG } from '@modules/common/components/SVGIcons/EditPredictionsSVG';
import {
  AccountTreeRounded,
  BookmarkRounded,
  EmailRounded,
  FilterListRounded,
  ManageAccountsRounded,
  PersonAddAltRounded,
  SearchRounded,
  SettingsRounded,
  SpaceDashboardOutlined,
} from '@mui/icons-material';
import { SettingsIcon } from 'common/Icons/Icons';
import { PermissionResource } from 'generated/graphql';
import { UserRowRoleType } from './store/types';
import { PermissionTableModule } from './types';

export const INVITE_CODE_QUERY_PARAM = 'inviteCode';

export const PERMISSION_MODULE_LABEL_MAP: Partial<
  Record<PermissionTableModule, string>
> = {
  [PermissionTableModule.AddIntegration]: 'Add Integrations',
  [PermissionTableModule.RemoveIntegration]: 'Remove/Disable Integrations',
  [PermissionTableModule.Metadata]: 'Manage Metadata (rename/hide/star)',
  [PermissionTableModule.UnifyMetadata]: 'Unify Metadata Fields',
  [PermissionTableModule.Taxonomy]: 'Add/Edit/Archive Taxonomy Nodes',
  [PermissionTableModule.Prediction]: 'Edit Predictions on Feedback Record',
  [PermissionTableModule.Artefact]:
    'Create/Edit your Saved Artifact on Enterpret',
  [PermissionTableModule.Template]: 'Configure Dashboard Templates',
  [PermissionTableModule.CustomFilter]:
    'Create/Edit your Custom Filters on Enterpret',
  [PermissionTableModule.AllCustomFilter]:
    'Create/Edit all Custom Filters on Enterpret',
  [PermissionTableModule.WorkspaceSettings]:
    'Workspace Settings (manage users, signup settings)',
  [PermissionTableModule.OutboundIntegration]:
    'Reporting and outbound Integrations',
  [PermissionTableModule.QueryData]: 'View and query data',
  [PermissionTableModule.Invite]: 'Invite Users',
};

export const PERMISSION_MODULE_ICON_MAP: Partial<
  Record<PermissionTableModule, JSX.Element>
> = {
  [PermissionTableModule.AddIntegration]: <SettingsIcon fill="currentColor" />,
  [PermissionTableModule.RemoveIntegration]: (
    <SettingsIcon fill="currentColor" />
  ),
  [PermissionTableModule.Metadata]: <SettingsRounded />,
  [PermissionTableModule.UnifyMetadata]: <SettingsRounded />,
  [PermissionTableModule.Taxonomy]: <AccountTreeRounded />,
  [PermissionTableModule.Prediction]: (
    <EditPredictionsSVG fillColor="currentColor" />
  ),
  [PermissionTableModule.Artefact]: <BookmarkRounded />,
  [PermissionTableModule.Template]: <SpaceDashboardOutlined />,
  [PermissionTableModule.CustomFilter]: <FilterListRounded />,
  [PermissionTableModule.AllCustomFilter]: <FilterListRounded />,
  [PermissionTableModule.WorkspaceSettings]: <ManageAccountsRounded />,
  [PermissionTableModule.OutboundIntegration]: <EmailRounded />,
  [PermissionTableModule.QueryData]: <SearchRounded />,
  [PermissionTableModule.Invite]: <PersonAddAltRounded />,
};

export const ALL_INVITABLE_ROLES = [
  UserRowRoleType.Admin,
  UserRowRoleType.Editor,
  UserRowRoleType.Member,
  UserRowRoleType.Viewer,
];

export const PERMISSION_RESOURCE_TO_MODULE_MAP: Record<
  PermissionResource,
  PermissionTableModule[]
> = {
  [PermissionResource.Integration]: [
    PermissionTableModule.AddIntegration,
    PermissionTableModule.RemoveIntegration,
  ],
  [PermissionResource.Metadata]: [
    PermissionTableModule.Metadata,
    PermissionTableModule.UnifyMetadata,
  ],
  [PermissionResource.Taxonomy]: [PermissionTableModule.Taxonomy],
  [PermissionResource.Prediction]: [PermissionTableModule.Prediction],
  [PermissionResource.Artefact]: [
    PermissionTableModule.Artefact,
    PermissionTableModule.CustomFilter,
  ],
  [PermissionResource.Template]: [PermissionTableModule.Template],
  [PermissionResource.Invite]: [PermissionTableModule.Invite],
  [PermissionResource.WorkspaceSettings]: [
    PermissionTableModule.WorkspaceSettings,
  ],
  [PermissionResource.OutboundIntegration]: [
    PermissionTableModule.OutboundIntegration,
  ],
  [PermissionResource.AllCustomFilters]: [
    PermissionTableModule.AllCustomFilter,
  ],
  [PermissionResource.AllArtefact]: [], // We don't support editing all artifacts
  [PermissionResource.Invalid]: [],
};
